// The customer-facing role lives in `repLevel`, not `title`: title is blank for
// most reps

// "(Team Coverage)" and the "First Year" marker, which lands mid-string.
const INTERNAL_PARTS = [/\s*\([^)]*\)\s*$/, /\bfirst year\b/i];

// Ladder rungs, not roles — blanked out like a missing role.
const NON_ROLE_LEVEL = /^level\s*\d+$/i;

export interface LiaisonRep {
  id?: number;
  firstName?: string;
  lastName?: string;
  repLevel?: string | null;
}

export function formatRepLevel(repLevel?: string | null): string {
  if (!repLevel) return "";

  const cleaned = INTERNAL_PARTS.reduce(
    (value, pattern) => value.replace(pattern, " "),
    repLevel,
  )
    .replace(/\s+/g, " ")
    .trim();

  return NON_ROLE_LEVEL.test(cleaned) ? "" : cleaned;
}

// Keyed off repLevel, never the name: some reps are named "TQS Site Manager".
export function isSiteManager(repLevel?: string | null): boolean {
  return /^site manager\b/i.test(formatRepLevel(repLevel));
}

function nameKey(rep: LiaisonRep): string {
  return `${rep.lastName ?? ""} ${rep.firstName ?? ""}`.trim();
}

// 0 Site Manager, 1 the agreement's primary rep, 2 everyone else. A rep who is
// both lands in tier 0 and keeps the Primary badge.
function rank(rep: LiaisonRep, primaryRepId?: number | null): number {
  if (isSiteManager(rep.repLevel)) return 0;
  if (primaryRepId != null && rep.id === primaryRepId) return 1;
  return 2;
}

// Primary is an agreement field, not a rep field, so the id has to be passed in.
export function byLiaisonOrder(primaryRepId?: number | null) {
  return (a: LiaisonRep, b: LiaisonRep): number =>
    rank(a, primaryRepId) - rank(b, primaryRepId) ||
    nameKey(a).localeCompare(nameKey(b), undefined, { sensitivity: "base" });
}
